<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script scoped>
export default {
  data() {
    return {}
  },
  methods: {
    // // 添加判断方法
    // isMobile() {
    //   console.log(this.$router.path,8888);
    //   let flag = navigator.userAgent.match(
    //     /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    //   )
    //   if (flag) {
    //     console.log('移动端打开')
    //      this.$router.replace('/');
    //   } else {
    //     console.log('PC端打开')
    //      this.$router.replace('/pc_index');
    //   }
    // }
  },
  mounted() {
    // this.isMobile()
  }
}
</script>
<style lang="less">
body {
  background-color: #eee;
  text-align: center;
}
.van-field__control {
  max-height: 150px;
}
</style>
